var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLowProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TrendUp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.0001 25.6416V17.6416C30.0001 17.3764 29.8947 17.122 29.7072 16.9345C29.5196 16.747 29.2653 16.6416 29.0001 16.6416C28.7349 16.6416 28.4805 16.747 28.293 16.9345C28.1054 17.122 28.0001 17.3764 28.0001 17.6416V23.2279L17.7076 12.9341C17.6147 12.8411 17.5044 12.7674 17.383 12.717C17.2616 12.6667 17.1315 12.6408 17.0001 12.6408C16.8687 12.6408 16.7385 12.6667 16.6171 12.717C16.4957 12.7674 16.3854 12.8411 16.2926 12.9341L12.0001 17.2279L3.70757 8.9341C3.51993 8.74646 3.26543 8.64104 3.00007 8.64104C2.7347 8.64104 2.48021 8.74646 2.29257 8.9341C2.10493 9.12174 1.99951 9.37624 1.99951 9.6416C1.99951 9.90697 2.10493 10.1615 2.29257 10.3491L11.2926 19.3491C11.3854 19.4421 11.4957 19.5158 11.6171 19.5662C11.7385 19.6165 11.8687 19.6424 12.0001 19.6424C12.1315 19.6424 12.2616 19.6165 12.383 19.5662C12.5044 19.5158 12.6147 19.4421 12.7076 19.3491L17.0001 15.0554L26.5863 24.6416H21.0001C20.7349 24.6416 20.4805 24.747 20.293 24.9345C20.1054 25.122 20.0001 25.3764 20.0001 25.6416C20.0001 25.9068 20.1054 26.1612 20.293 26.3487C20.4805 26.5362 20.7349 26.6416 21.0001 26.6416H29.0001C29.2653 26.6416 29.5196 26.5362 29.7072 26.3487C29.8947 26.1612 30.0001 25.9068 30.0001 25.6416Z",
    fill: "#F04438"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowProduct);
export default __webpack_public_path__ + "static/media/low_product.6ec5335c1bec9a6f2d2f4e0edc18c860.svg";
export { ForwardRef as ReactComponent };